<script>
import { mapGetters, mapState } from 'vuex';
import XmlChannelStatusCard from './XmlChannelStatusCard';

export default {
  name: 'XmlChannelStatusCards',
  components: {
    XmlChannelStatusCard,
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 21, // Divisible by 3
      totalVisible: 10,
    };
  },
  computed: {
    ...mapGetters({
      filteredXmlChannels: 'xmlChannelStatus/filteredXmlChannels',
    }),
    ...mapState({
      loading: state => state.xmlChannelStatus.xmlChannels.loading,
      error: state => state.xmlChannelStatus.xmlChannels.error,
    }),
    paginatedXmlChannels() {
      const fromIndex = (this.page - 1) * this.itemsPerPage;
      const toIndex = this.page * this.itemsPerPage;
      return this.filteredXmlChannels.slice(fromIndex, toIndex);
    },
    pages() {
      return Math.ceil(this.filteredXmlChannels.length / this.itemsPerPage);
    },
  },
  methods: {
    openJobList(xmlChannel) {
      this.$emit('open-job-list', xmlChannel);
    },
    activateLatestJob(xmlChannel) {
      this.$emit('activate-latest-job', xmlChannel);
    },
  },
};
</script>

<template>
  <v-container grid-list-md pt-1>
    <v-layout class="row xml-channel-status-cards__header">
      <v-flex v-if="pages > 1" xs-3 text-xs-center>
        <v-pagination
          v-model="page"
          :length="pages"
          :total-visible="totalVisible"
        />
      </v-flex>
      <v-flex xml-channel-status-cards__refresh>
        <v-btn @click="$emit('refresh')" icon>
          <v-icon :class="{ 'icon-spin': loading }">refresh</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex v-for="(xmlChannel, index) in paginatedXmlChannels" :key="index" xs4>
        <xml-channel-status-card
          @open-job-list="openJobList"
          @activate-latest-job="activateLatestJob"
          :xml-channel="xmlChannel"
        />
      </v-flex>
      <v-flex>
        <v-alert :value="!loading && error" type="error">
          {{ $t('xmlChannelStatus.xmlChannelStatusCard.error') }}
        </v-alert>
        <v-alert :value="!loading && !error && paginatedXmlChannels.length === 0" type="warning">
          {{ $t('xmlChannelStatus.xmlChannelStatusCard.noContent') }}
        </v-alert>
      </v-flex>
    </v-layout>
    <v-layout v-if="pages > 1" row>
      <v-flex mt-3 text-xs-center>
        <v-pagination
          v-model="page"
          :length="pages"
          :total-visible="totalVisible"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
  .xml-channel-status-cards {
    &__header {
      position: relative;
      min-height: 50px;
    }

    &__refresh {
      position: absolute;
      right: 0;
      top: -3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusCards.vue